/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import HorizontalTeamCard from "parts/Cards/TeamCards/HorizontalTeamCard";

// Images
import team1 from "assets/images/6.jpg";
import team2 from "assets/images/22.jpg";
import team3 from "assets/images/16.jpg";
import team4 from "assets/images/35.jpg";

function Team() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="info"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
            <MKTypography variant="h3" color="white">
            Why Choose Us?
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.8}>
  At HP Tech Solutions, we're more than just a generative AI provider—we're your partner in innovation. Our mission is to leverage cutting-edge AI technologies to deliver customized, secure, and scalable solutions that drive efficiency, creativity, and growth in an ever-evolving digital landscape.

  Founded by a team of seasoned experts, we combine advanced AI capabilities with a deep understanding of business needs to solve complex challenges for organizations of all sizes. From automated content generation to real-time data analysis and speech processing, we provide a full suite of generative AI solutions designed to meet your unique goals.
</MKTypography>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team2}
                name="Cutting-Edge Technology"
                position={{ color: "info", label: "Technology" }}
                description="We harness the latest advancements in AI to deliver exceptional performance and accuracy."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team3}
                name="Customized Solutions"
                position={{ color: "info", label: "Business goals" }}
                description="Our services are tailored to meet your unique business needs, ensuring maximum impact."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team4}
                name="Time & Cost Efficiency"
                position={{ color: "info", label: "ROI" }}
                description="Automate complex tasks to save time and reduce operational costs."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team4}
                name="Expert Support"
                position={{ color: "info", label: "Support" }}
                description="Work with a team of skilled professionals dedicated to helping you succeed."
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Team;
